import { styled } from 'stitches.config'
import { VerticalSeparator } from '../EssentialNutrients/EssentialNutrients.styles'

export const Description = styled('div', {
  flex: 2,

  '@bp2': {
    paddingRight: '$6',
  },

  '@bp3': {
    paddingRight: '$11',
  },
})

export const TitleWrapper = styled('div', {
  '& img': {
    size: '$12',
  },

  '@bp2': {
    order: 2,
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp3': {
    paddingLeft: '$11',
    paddingRight: '$11',
  },
})

export const Wrapper = styled('div', {
  width: '100%',

  '@bp2': {
    order: 2,
    paddingLeft: '$6',
  },

  '@bp3': {
    paddingLeft: '$11',
  },
})

export const SafeFoodRoot = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  maxWidth: '$max',
  paddingLeft: '$3',
  paddingRight: '$3',

  '@bp2': {
    paddingLeft: 0,
    paddingRight: 0,

    '&': {
      [`${VerticalSeparator}`]: {
        order: 1,
      },
    },
  },

  '@bp3': {
    paddingBottom: '$9',
  },
})

export const Stamp = styled('div', {
  alignSelf: ' center',

  '@bp2': {
    alignSelf: ' flex-end',
  },
})
